export const TEST_ID = {
  changePassword: 'changePassword',
};
